const HistoryBoldIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="92"
      viewBox="0 0 92 92"
      {...props}
      width="92"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1983_8148)">
        <path
          d="M49.8333 11.5C30.7816 11.5 15.3333 26.9483 15.3333 46H3.83325L18.7449 60.9117L19.0133 61.4483L34.4999 46H22.9999C22.9999 31.165 34.9983 19.1667 49.8333 19.1667C64.6683 19.1667 76.6666 31.165 76.6666 46C76.6666 60.835 64.6683 72.8333 49.8333 72.8333C42.4349 72.8333 35.7266 69.805 30.8966 64.9367L25.4533 70.38C31.7016 76.6283 40.2882 80.5 49.8333 80.5C68.8849 80.5 84.3333 65.0517 84.3333 46C84.3333 26.9483 68.8849 11.5 49.8333 11.5ZM45.9999 30.6667V49.8333L62.2916 59.4933L65.2433 54.5867L51.7499 46.575V30.6667H45.9999Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1983_8148">
          <rect fill="white" height="92" width="92" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HistoryBoldIcon;
